// sliders.js
import Swiper from 'swiper/bundle';


export function initValuesSlider() {
    const heroSlider = document.querySelector('.js-values-slider');

    if (heroSlider) {
        new Swiper(heroSlider, {
            loop: false,
            slidesPerView: 4,
            spaceBetween: 37,
            pagination: {
                el: '.js-values-slider .swiper-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: '.swiper-button-next-custom',
                prevEl: '.swiper-button-prev-custom',
            },
            breakpoints: {
                0: {
                    slidesPerView: 1
                },
                768: {
                    slidesPerView: 2
                },
                1024: {
                    slidesPerView: 4
                }
            }
        });
    }
}

export function initTeamSlider() {
    document.querySelectorAll('.js-team-slider').forEach(function (el) {
        const section = el.closest('.block-team-slider');
        new Swiper(el, {
            loop: false,
            slidesPerView: 3,
            spaceBetween: 25,
            navigation: {
                nextEl: section ? section.querySelector('.swiper-button-next-team') : '.swiper-button-next-team',
                prevEl: section ? section.querySelector('.swiper-button-prev-team') : '.swiper-button-prev-team',
            },
            breakpoints: {
                0: {
                    slidesPerView: 1,
                },
                768: {
                    slidesPerView: 2,
                },
                1200: {
                    slidesPerView: 3,
                }
            }
        });
    });
}

export function initTestimonialsSlider() {
    document.querySelectorAll('.block-testimonials').forEach(function (block) {
        var el = block.querySelector('.js-testimonials-swiper');
        if (!el) return;

        var swiper = new Swiper(el, {
            loop: false,
            slidesPerView: 1,
            effect: 'fade',
            fadeEffect: { crossFade: true },
            navigation: {
                nextEl: block.querySelector('.swiper-button-next-testimonials'),
                prevEl: block.querySelector('.swiper-button-prev-testimonials'),
            },
        });

        // Vertical nav buttons → slide to index
        var navItems = block.querySelectorAll('.block-testimonials__nav-item');
        navItems.forEach(function (btn) {
            btn.addEventListener('click', function () {
                var index = parseInt(btn.dataset.slideIndex, 10);
                swiper.slideTo(index);
            });
        });

        // Sync active state on slide change
        swiper.on('slideChange', function () {
            navItems.forEach(function (btn) { btn.classList.remove('is-active'); });
            var active = block.querySelector('[data-slide-index="' + swiper.activeIndex + '"]');
            if (active) active.classList.add('is-active');
        });
    });
}

export function initTestimonialsCarousel() {
    document.querySelectorAll('.block-testimonials-slider').forEach(function (block) {
        var el = block.querySelector('.js-testimonials-slider-swiper');
        if (!el) return;

        new Swiper(el, {
            loop: false,
            slidesPerView: 3.2,
            spaceBetween: 24,
            navigation: {
                nextEl: block.querySelector('.swiper-button-next-ts'),
                prevEl: block.querySelector('.swiper-button-prev-ts'),
            },
            breakpoints: {
                0: {
                    slidesPerView: 1.1,
                },
                768: {
                    slidesPerView: 2.2,
                },
                1200: {
                    slidesPerView: 3.2,
                }
            }
        });
    });
}

export function initMediaSlider() {
    document.querySelectorAll('.block-media-slider').forEach(function (block) {
        var el = block.querySelector('.js-media-slider-swiper');
        if (!el) return;

        var opts = {
            loop: false,
            slidesPerView: 3.2,
            spaceBetween: 24,
            navigation: {
                nextEl: block.querySelector('.swiper-button-next-media'),
                prevEl: block.querySelector('.swiper-button-prev-media'),
            },
            breakpoints: {
                0: {
                    slidesPerView: 1.1,
                },
                768: {
                    slidesPerView: 2.2,
                },
                1200: {
                    slidesPerView: 3.2,
                }
            }
        };

        if (block.dataset.autoplay === 'true') {
            opts.autoplay = { delay: 4000, disableOnInteraction: false };
        }

        new Swiper(el, opts);
    });
}
